import { DiscountType } from './Promo';
import { ISku } from './Sku';

export interface IPlan {
    id: string;
    name: string;
    userDescription: string;
    planType: PlanType;
    autopayDiscount: IAutopayDiscount;
    customerAppreciationDiscounts: ICustomerAppreciationDiscount[];
    linePrice: number[];
    legalInformation: string[];
    features: string[];
    recommended: boolean;
    costPerMonthDescription?: string[];
    dataCostPerMonthPerLine?: string[];
    costPerNumberOfLines?: string[];
    sortOrder: number;
    baseSkus: ISku[];
    maxLines: number;
    isVisible: boolean;
    cartDisclaimer: string;
}

export const DefaultPlan = (): IPlan => {
    return {
        sortOrder: 0,
        customerAppreciationDiscounts: [],
        autopayDiscount: DefaultAutopayDiscount(),
        features: [],
        id: '',
        legalInformation: [],
        linePrice: [],
        name: 'Plan',
        planType: PlanType.UnlimitedData,
        recommended: false,
        userDescription: '',
        baseSkus: [],
        maxLines: 0,
        isVisible: false,
        cartDisclaimer: ''
    };
};

export interface IAutopayDiscount {
    hasDiscount: boolean;
    discountType: DiscountType;
    discountAmount: number;
}

export const DefaultAutopayDiscount = (): IAutopayDiscount => {
    return {
        discountAmount: 0,
        discountType: DiscountType.Percent,
        hasDiscount: false
    };
};

export interface ICustomerAppreciationDiscount {
    name: string;
    discountType: DiscountType;
    discountAmount: number;
    exclusiveDiscount: boolean;
    sku: string;
    requiresValidation: boolean;
}

export const DefaultCustomerAppreciationDiscount = (): ICustomerAppreciationDiscount => {
    return {
        discountAmount: 0,
        discountType: DiscountType.Percent,
        name: '',
        exclusiveDiscount: false,
        sku: '',
        requiresValidation: false
    };
};

export enum PlanType {
    UnlimitedData,
    SharedData,
    Prepaid,
    HotspotData,
    HomePhone,
    HomeInternet
}

export const PlanTypeMap: { [key: number]: string } = {
    [PlanType.UnlimitedData as number]: 'Unlimited Data',
    [PlanType.SharedData as number]: 'Shared Data',
    [PlanType.Prepaid as number]: 'Prepaid',
    [PlanType.HotspotData as number]: 'Hotspot Data',
    [PlanType.HomePhone as number]: 'Home Phone',
    [PlanType.HomeInternet as number]: 'Home Internet'
};
